import { useTranslation } from 'react-i18next';

import { refreshMapLayout } from '@/lib/leaflet/mobileMapFix';
import type { IncidentState } from '@/signalr';
import type { IncidentPanel } from './incidentPanel';
import { MobileMenuButtonItem } from './MobileMenuButtonItem';
import { MobileMenuMoreSubmenu } from './MobileMenuMoreSubmenu';

export type IncidentDetailMobilePanelSwitchProps = {
  activePanel: IncidentPanel;
  onActivePanelChanged: (panel: IncidentPanel) => void;
  incidentState: IncidentState | null;
};

export function IncidentDetailMobilePanelSwitch({
  activePanel,
  onActivePanelChanged,
  incidentState,
}: IncidentDetailMobilePanelSwitchProps) {
  const { t } = useTranslation();

  const setActive = (panel: IncidentPanel) => {
    refreshMapLayout();
    onActivePanelChanged(panel);
  };

  return (
    <div className="incident-detail-layout__mobile-menu d-flex d-tablet-none justify-content-around bg-psap-theme">
      <MobileMenuButtonItem
        icon="fal fa-memo-circle-info"
        title={t('Incident_MobileLayout_TabTitle_Caller')}
        onClick={() => setActive('dataPanel')}
        isActive={activePanel === 'dataPanel'}
      />

      <MobileMenuButtonItem
        icon="fal fa-map-marker-alt"
        title={t('Incident_MobileLayout_TabTitle_Map')}
        onClick={() => setActive('map')}
        isActive={activePanel === 'map'}
      />

      <MobileMenuButtonItem
        icon="fal fa-video"
        title={t('Incident_MobileLayout_TabTitle_Video')}
        onClick={() => setActive('videoPanel')}
        isActive={activePanel === 'videoPanel'}
      />

      <MobileMenuButtonItem
        icon="fal fa-comments"
        title={t('Incident_MobileLayout_TabTitle_Chat')}
        onClick={() => setActive('chat')}
        isActive={activePanel === 'chat'}
      />

      <MobileMenuMoreSubmenu incidentState={incidentState} />
    </div>
  );
}
